module.exports = __webpack_public_path__ + "img/007-house.5b200888.png";